import React from 'react'

import compose  from 'vegas-js-core/src/functors/compose'
import isString from 'vegas-js-core/src/isString'

import moment from 'moment/moment'

import PropTypes from 'prop-types'

import clean  from 'vegas-js-core/src/objects/clean'
import format from 'vegas-js-core/src/strings/fastformat'

import initApp from '../../../../../contexts/app/initApp'

import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

import { Grid } from '@material-ui/core'

import RateReviewIcon from '@material-ui/icons/RateReview'
import EventIcon     from '@material-ui/icons/Event'
import SwapHorizIcon from '@material-ui/icons/SwapHoriz'

import api from '../../../../../configs/api'

import LabelItem      from '../../../../../components/items/LabelItem'
import PrintButton    from '../../../../../components/buttons/PrintButton'
import ThingContainer from '../../../../containers/ThingContainer'

import AbortionDeclaration from '../../../../print/livestock/reviews/AbortionDeclaration'
import AbortionReview      from '../../../../../things/livestock/reviews/AbortionReview'
import Veterinarian        from '../../../../../things/Veterinarian'

const cellStyle = 'flex flex-row items-center w-full' ;

const styles = () => (
{
    root :
    {
        width : '100%'
    }
});

const half =
{
    sm : 6 ,
    xs : 12
};

class Abortion extends ThingContainer
{
    editPrepare = ( item ) =>
    {
        if( item )
        {
            let {
                date,
                distance,
                subjectOf:observation
            }
            = item ;

            date = date instanceof Date
                 ? moment(date).toISOString()
                 : null ;

            distance = parseInt(distance) ;
            if( isNaN(distance) || (distance < 0) )
            {
                distance = 0 ;
            }

            if( observation )
            {
                let { review } = observation ;
                if( review )
                {
                    review.date     = date ;
                    review.distance = distance ;
                    review = clean(review.toObject()) ;
                    return { review:JSON.stringify(review) } ;
                }
            }
        }
        return null ;
    };

    editUri = ( path, props ) =>
    {
        const { thing } = props ;
        if( thing )
        {
            const { id } = thing ;
            if( id )
            {
                return api.observations.url + '/' + id ;
            }
        }
        return null ;
    };

    getContent = () =>
    {
        let { thing } = this.props;

        const locale = this.getLocale() ;

        if( thing )
        {
            const { review } = thing ;
            if( review instanceof AbortionReview )
            {
                const { items } = locale ;
                if( items )
                {
                    let {
                        date,
                        distance
                    }
                    = review ;

                    if( isString( date ) )
                    {
                        date = moment(date).format(locale.datePattern)
                    }

                    return (
                    <Grid container spacing={4}>
                        <Grid item {...half}>
                            <div className={cellStyle}>
                                <EventIcon size='1.5em' className='mr-16' />
                                <LabelItem title = { items.date }>
                                    { isString(date) && date !== '' ? date : items.empty }
                                </LabelItem>
                            </div>
                        </Grid>
                        <Grid item {...half}>
                            <div className={cellStyle}>
                                <SwapHorizIcon size='1.5em' className='mr-16' />
                                <LabelItem title = { items.distance.title }>
                                    { format(items.distance.label,distance) }
                                </LabelItem>
                            </div>
                        </Grid>
                    </Grid>);
                }
            }
        }

        return null ;
    };

    getCustomOptions = () =>
    {
        const { printable } = this.props ;
        if( printable )
        {
            let veterinarians = null ;

            const { thing } = this.props ;
            if( thing )
            {
                let { authority } = thing ;
                if( authority instanceof Array && authority.length > 0 )
                {
                    veterinarians = authority.filter( item => item instanceof Veterinarian ) ;
                }
            }

            const locale = this.getLocale() ;
            return (
            <PrintButton
                disabled = { !(veterinarians instanceof Array) || (veterinarians.length === 0) }
                locale   = { locale }
                onClick  = { () =>
                {
                    if( veterinarians instanceof Array )
                    {
                        if( veterinarians.length === 1 )
                        {
                            this.openPrintDialog( this.getDocument( veterinarians[0] ) ) ;
                        }
                        else
                        {
                            this.openSuggestionDialog( veterinarians ) ;
                        }
                    }
                }}
            />);
        }
        return null ;
    } ;

    getDocument = ( item = null ) =>
    (
        <AbortionDeclaration
            thing        = { this.props.thing }
            veterinarian = { item }
        />
    );

    getEntry = () =>
    {
        const { thing } = this.props ;
        let init = null ;
        if( thing )
        {
            const { review } = thing ;
            if( review instanceof AbortionReview )
            {
                const {
                    date,
                    distance
                }
                = review ;

                init = {
                    date,
                    distance
                }
            }
        }
        return new AbortionReview( { ...init, subjectOf:thing } ) ;
    };

    getLocale = () => this.props.locale.things.livestock.reviews.abortion ;

    onEdit = this.change ;

    onSuggest = item =>
    {
        this.timeout = setTimeout( this.openPrintDialog , 250, this.getDocument( item ) ) ;
    };

    unmount = () =>
    {
        clearTimeout(this.timeout) ;
        this.timeout = null ;
    };
}

Abortion.defaultProps =
{
    ...ThingContainer.defaultProps,
    icon       : <RateReviewIcon/>,
    optionMode : 'custom',
    printable  : true,
    titleMode  : 'edit'
};

Abortion.propTypes =
{
    ...ThingContainer.propTypes,
    printable : PropTypes.bool
};

export default compose( withStyles( styles ) , withRouter, initApp )( Abortion ) ;
